import * as queryString from 'query-string';

const querySettingsKey = 'kuntoutussaatio.querysettings';

export function CheckQueryParamSettings(query: string): boolean {
	let found = false;
	const parsed = queryString.parse(query);
	if (parsed['culture'] !== undefined) {
		sessionStorage.setItem(`${querySettingsKey}.culture`, parsed['culture'] as string);
		found = true;
	} if (parsed['min'] !== undefined) {
		sessionStorage.setItem(`${querySettingsKey}.min`, 'true');
		found = true;
	}
	return found;
}

export function GetQueryCulture(): string | null {
	return sessionStorage.getItem(`${querySettingsKey}.culture`);
}

export function hideHeader(): boolean {
	return sessionStorage.getItem(`${querySettingsKey}.min`) !== null ? true : false;
}


